import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { LgvGridManager } from './grid-manager';

@Component({
    selector: 'lgv-grid-header',
    template: `
    <div *ngIf="!IsCurrentSortField" class="GridHeader" (click)="OnHeaderClicked()">{{HeaderText}}  <fa-icon  icon="sort"></fa-icon></div>
    <div *ngIf="IsCurrentSortField" class="GridHeader" (click)="OnHeaderClicked()">{{HeaderText}}  <fa-icon  icon="{{Icon}}"></fa-icon></div>
  `,
})

export class LgvGridHeaderComponent implements OnInit, OnDestroy {

    //Mgr: GridManager;
    @Input() Mgr: LgvGridManager;

    @Input() HeaderText: string;
    @Input() SortField: string;

    CurrentSortField: string;
    CurrentSortDirection: string;

    get IsCurrentSortField(): boolean { return this.CurrentSortField == this.SortField }

    get Icon() {

        if (!this.IsCurrentSortField) {
            return "";
        }

        if (this.CurrentSortDirection == "asc") {
            return "caret-up";
        }
        else {
            return "caret-down";
        }
    }
    onDestroy$ = new Subject();

    constructor() {
    }

    ngOnInit() {
        this.InitFromGridMgr();

        this.Mgr.OnRefreshData.pipe(takeUntil(this.onDestroy$)).subscribe(
            (x) => {
                //console.log('YYY GridMgr.OnRefreshData() YYY');
                this.InitFromGridMgr();
            }
        );
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    InitFromGridMgr() {
        this.CurrentSortField = this.Mgr.CurrentSortColumn;
        this.CurrentSortDirection = this.Mgr.CurrentSortDirection;
    }

    OnHeaderClicked() {
        let sameField: boolean = this.CurrentSortField == this.SortField;
        this.CurrentSortField = this.SortField;
        this.CurrentSortDirection = !sameField || this.CurrentSortDirection != "asc" ? "asc" : "desc";
        this.Mgr.OnSortChange(this.CurrentSortField, this.CurrentSortDirection);
    }
}
